export { Trash4 as default } from './Trash4';
